import { SET_USER_TOKEN } from "../constants";

export default (srcmtoken) => ({
  type: SET_USER_TOKEN,
  srcmtoken,
});
